export type Stage =
  | "arquivos_prontos"
  | "enviada_wts"
  | "aceite"
  | "liquidado"
  | "comprado"
  | "baixado";

/** "bloqueado": seria candidato, mas tem bloqueio vigente do documento (bloqueio_entregador) */
/** "franquia_pausada": não recebeu porque a franquia está com oferta pausada (cadastro_franquia_entrego.oferta_ativa) */
export type LastStage = Stage | "nao_enviada" | "bloqueado" | "franquia_pausada";

export type OpsFilter = "all" | "entrego" | "muve" | "indrive";

/** Filtro da coluna "Parou em" — "all" desliga o filtro */
export type LastStageFilter = LastStage | "all";

/** Progressão do funil, usada para ordenar a coluna "Parou em" */
export const LAST_STAGE_ORDER: LastStage[] = [
  "bloqueado",
  "franquia_pausada",
  "nao_enviada",
  "arquivos_prontos",
  "enviada_wts",
  "aceite",
  "liquidado",
  "comprado",
  "baixado",
];

export interface Pagination {
  page: number;
  pageSize: number;
  totalRows: number;
  totalPages: number;
}

export interface OverviewFunnel {
  candidatos: number;
  bloqueados: number;
  pausados: number;
  arquivosProntos: number;
  enviadas: number;
  naoEnviadas: number;
  aceites: number;
  liquidadas: number;
  compradas: number;
  baixadas: number;
}

export interface OverviewRow {
  cnpjCpf: string;
  telefone: string;
  ops: string;
  dataRomaneio: string;
  dataVencimento: string;
  valorFace: number;
  valorCompra: number;
  stages: {
    arquivosProntos: boolean;
    enviada: boolean;
    aceite: boolean;
    liquidado: boolean;
    comprado: boolean;
    baixado: boolean;
  };
  lastStage: LastStage;
  bloqueio?: BloqueioInfo | null;
}

/** Bloqueio vigente em bloqueio_entregador (documento inteiro na ops ou só o telefone) */
export interface BloqueioInfo {
  escopo: "documento" | "telefone";
  ops: string;
  origem: "gestor" | "cliente";
  motivoCodigo: string | null;
  motivoTexto: string | null;
  criadoPor: string;
  criadoEm: string;
}

export interface OverviewResult {
  mode: "overview";
  ops: string;
  date: string;
  lastStage: LastStage | null;
  wtsOk: boolean;
  checkoutStatus: string | null;
  stageOrder: Stage[];
  funnel: OverviewFunnel;
  funnelByOps?: Record<string, OverviewFunnel>;
  rows: OverviewRow[];
  pagination: Pagination;
}

export interface CadastroResult {
  cadastroId: string;
  cpf: string | null;
  cnpj: string | null;
  numeroDocumento: string;
  telefone: string;
  nome: string | null;
  ops: string;
  status: string;
  cadastroAtivo: boolean;
  bloqueio: BloqueioInfo | null;
  enviada: boolean;
  mensagemEnviadaTexto: string;
  lastStage: LastStage;
  stages: {
    enviada: boolean;
    aceite: boolean;
    liquidado: boolean;
    comprado: boolean;
    baixado: boolean;
  };
  solicitacao: {
    solId: string;
    dataRomaneio: string;
    dataVencimento: string;
    valorFace: number;
    valorCompra: number;
  } | null;
  solicitacoes: SolicitacaoResumo[];
}

export interface SolicitacaoResumo {
  solId: string;
  ops: string;
  dataRomaneio: string | null;
  dataVencimento: string | null;
  requestedDatetime: string | null;
  valorFace: number;
  valorCompra: number;
  comprovanteBancario: string | null;
  comprado: boolean;
  liquidado: boolean;
  baixado: boolean;
}

export interface IndividualResult {
  mode: "individual";
  searchedBy: { cpf: string; cnpj: string; telefone: string };
  dataInicio: string;
  hasMultipleCadastros: boolean;
  cwUsed?: boolean;
  stageOrder: Stage[];
  cadastros: CadastroResult[];
}

export interface SearchFormData {
  telefone: string;
  cpf: string;
  cnpj: string;
}
